<template>
  <div
    class="purchase-payment-details"
  >
    <!-- This should be moved to a separate component. -->

    <table class="table">
      <tr>
        <td>Merchant Code</td>
        <td>{{ purchase.merchant_code || 'n/a' }} </td>
      </tr>
      <tr>
        <td>Merchant Email</td>
        <td>
          <a
            :href="'mailto:' + purchase.merchant_email"
            v-if="purchase.merchant_email"
          >
            {{ purchase.merchant_email }}
          </a>
          <span
            v-else
          >
            n/a
          </span>
        </td>
      </tr>
      <tr>
        <td>Payment ID</td>
        <td>
          {{ purchase.external_payment_id }}
          <span
            class="badge badge-sm badge-warning"
            v-if="purchase.sandbox"
          >
            Sandbox
          </span>
        </td>
      </tr>
      <tr>
        <td>Payment Sale ID</td>
        <td>{{
          purchase.external_payment_sale_id || (
            purchase.is_external_purchase ? 'Sale has not been completed yet' : 'n/a'
          )
          }}</td>
      </tr>
      <tr>
        <td>Payment Subscription ID</td>
        <td>
          <span
            v-if="purchase.external_payment_subscription_id"
          >
            {{ purchase.external_payment_subscription_id  }}
            <a
              class="btn btn-sm btn-warning"
              :href="externalPaymentSubcriptionUrl"
              target="_blank"
            >
              View in PayPal
            </a>
          </span>
          <span
            v-else
          >
            n/a
          </span>
        </td>
      </tr>
      <tr>
        <td>Payment Link</td>
        <td>
          <span
            v-if="purchase.external_payment_url"
          >
            <a
              :href="purchase.external_payment_url"
            >
              {{ purchase.external_payment_url }}
            </a>
          </span>
          <span
            v-else
          >
            n/a
          </span>
        </td>
      </tr>
      <tr>
        <td>Payment Token</td>
        <td>{{ purchase.external_payment_token || 'n/a' }}</td>
      </tr>
      <tr>
        <td>Payment User ID</td>
        <td>{{ purchase.external_payer_id }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    purchase: {
      type: Object,
      default: () => {},
      required: true
    }
  },

  computed: {
    externalPaymentSubcriptionUrl () {
      return `https://www.paypal.com/billing/subscriptions/${this.purchase.external_payment_subscription_id}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasePaymentsDetails.vue